import React, {PropTypes} from 'react'; 
import classNames from 'classnames';

const TournamentSearch = ({
  searchValue,
  onSearchEnterKeyPress,
  onSearchClick,
  onSearchValueChange
}) => (
    <div className="animated fadeIn flex wrap">
      <div className={classNames(
        'input-group input-group-lg'
      )} style={{"paddingBottom": "16px"}}>
        <input type="text"
             autoFocus
             placeholder="Type your search here..."
             className="form-control"
             value={searchValue}
             onChange={event => onSearchValueChange(event.target.value)}
             onKeyDown={onSearchEnterKeyPress}
      />
      <span className="input-group-btn">
        <button className="btn btn-primary"
                type="button"
                onClick={onSearchClick}><i className="fa fa-search" /></button>
      </span>
    </div>
  </div>
);

TournamentSearch.propTypes = { 
  onSearchClick: PropTypes.func,
  onSearchEnterKeyPress: PropTypes.func,
  onSearchValueChange: PropTypes.func,
  searchValue: PropTypes.string
};

TournamentSearch.defaultProps = {
  searchValue: ''
};

export default TournamentSearch;



// WEBPACK FOOTER //
// ./src/features/tournament/tournamentList/TournamentSearch.jsx